import { request } from "./request";

const BASE_URL = "/api/profile";

export default {
  async me() {
    return await request(`${BASE_URL}/me`);
  },

  async delete(password) {
    return await request({
      url: BASE_URL,
      method: "delete",
      data: { password },
    });
  },

  async changePassword(currentPassword, password) {
    return await request({
      url: `${BASE_URL}/change_password`,
      method: "post",
      data: {
        password,
        current_password: currentPassword,
      },
    });
  },
};
